import {Fragment, useCallback, useContext, useEffect, useMemo, useState} from 'react'

import Steps from './Steps'
import Slider from './Slider'
import Form from './Form'
import AppContext from '../AppContext'
import checkConditions from '../checkConditions'

export default function LeadForm (props) {
  const appContext = useContext(AppContext)
  const [stage, setStage] = useState('questions')
  const [flowId, setFlowId] = useState('start')
  const [leaving, setLeaving] = useState(false)
  const [page, setPageRaw] = useState(0)
  const [submitError, setSubmitError] = useState()
  const flow = useMemo(() => {
    return props.flows?.[flowId]
  }, [flowId])

  const setPage = useCallback((newPageNumber) => {
    const oldPageNumber = page

    const newPage = flow?.steps?.[newPageNumber]
    if (!newPage || !newPage.conditions) {
      setPageRaw(newPageNumber)
      return
    }

    if (checkConditions(newPage.conditions, appContext.state)) {
      setPageRaw(newPageNumber)
    } else {
      if (newPageNumber > oldPageNumber) {
        setPageRaw(newPageNumber + 1)
      } else {
        setPageRaw(newPageNumber - 1)
      }
    }
  }, [flow, page, appContext.state])

  return (
    <div key={flowId}>
      {stage === 'questions' ? (
        <>
          <Steps
            active={page+1}
            steps={flow?.steps.length || 0}
            hidden={flowId === 'start'}
          />
          <Slider
            page={page}
            leaving={leaving}
          >
            {flow?.steps?.map((step, index) => (
              <Form
                isOwnState={flowId === 'start'}
                key={index}
                {...step}
                disabled={leaving}
                setPage={setPage}
                navigate={to => {
                  setLeaving(true)
                  setTimeout(() => {
                    setFlowId(to)
                    setPage(0)
                    setLeaving(false)
                  }, 500)
                }}
                backDisabled={page === 0 && flowId === 'start'}
                onBack={step.onBack || (page === 0 && flowId === 'start' ? undefined : () => {
                  if (page === 0) {
                    if (flowId !== 'start') {
                      setFlowId('start')
                    }
                  } else {
                    setPage(page - 1)
                  }
                })}
                onNext={step.onNext || (async ({state}) => {
                  appContext.applyState(state)
                  if (page < flow.steps?.length - 1) {
                    setPage(page + 1)
                  } else if (flowId !== 'start' && flowId !== 'finish') {
                    setStage('confirm')
                  }
                })}
              />
            ))}
          </Slider>
        </>
      ) : stage === 'confirm' ? (
        <>
          <Steps hidden />
          <Form
            title={flow.confirm.title}
            description={flow.confirm.description}
            onBack={() => {
              setStage('questions')
            }}
            nextLabel={flow.confirm.buttonLabel}
            onNext={async () => {
              setSubmitError()
              try {
                await appContext.submit()
                setStage('thankyou')
              } catch (err) {
                setSubmitError(err)
              }
            }}
          >
            <div className="wp-block-gds-lead-form__summary">
              <strong>{flow.confirm.summaryLabel}</strong>
              <ul>
                {Object.entries(appContext.state).map(([key, value]) => (
                  <Fragment key={key}>
                    {typeof value === 'string' ? (
                      <li>{key}: {value}</li>
                    ) : typeof value === 'number' ? (
                      <li>{key}: {value}</li>
                    ) : Array.isArray(value) ? (
                      <li>{key}: {value.map(value => (
                        typeof value === 'string' ? value
                        : typeof value === 'number' ? value
                        : typeof value === 'object' ? (
                          Object.entries(value).map(([key, value]) => `${key}: ${value}`).join(', ')
                        ) : ''
                      )).join('; ')}</li>
                    ) : null}
                  </Fragment>
                ))}
              </ul>
              {submitError && (
                <p>Jotain meni vikaan. Yritä uudestaan.</p>
              )}
            </div>
          </Form>
        </>
      ) : stage === 'thankyou' ? (
        <>
          <Steps hidden />
          <Form
            title={flow.thankYou.title}
            backLabel="Palaa etusivulle"
            onBack={() => {
              window.location.href = '/'
            }}
          >
            <div dangerouslySetInnerHTML={{__html: flow.thankYou.descriptionHtml}} style={{marginBottom: '30px'}} />
          </Form>
        </>
      ) : null}
    </div>
  )
}